import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Full-screen loader with branded styling.
 * Uses theme tokens for all visual properties.
 */
const Loader = ({ sx, size = 48, message }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: 'background.default',
        gap: 2,
        ...sx,
      }}
      role="status"
      aria-label={message || "Loading"}
    >
      <CircularProgress
        size={size}
        thickness={3}
        sx={{
          color: 'primary.main',
        }}
      />
      {message && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontWeight: 500,
            mt: 1,
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Loader;
